// Copyright ©️ 2026 eVolve MEP, LLC

import type { Task } from '@evolvemep/api-ts';
import { notifications } from '@mantine/notifications';

import { ReopenTaskModal, type ReopenTaskModalModeProps } from 'modules/Shop/Tasks/TaskViewer/ReopenTaskModal';

type Props = {
  opened: boolean;
  onClose: () => void;
  /** Called with the updated task once it has been uncompleted. */
  onTaskUncompleted: (task: Task) => void;
} & ReopenTaskModalModeProps;

/**
 * Confirms sending a completed task that was never started back to not started.
 *
 * Only a completed task with no accrued time can be uncompleted — a task that was started is reopened with
 * `ResumeTaskModal` instead.
 */
export const UncompleteTaskModal = ({ onTaskUncompleted, ...props }: Props) => (
  <ReopenTaskModal
    {...props}
    title="Uncomplete task"
    confirmationText="Uncomplete"
    gerund="uncompleting"
    outcome="be set back to Not started"
    onTaskReopened={(updatedTask, workCellTask) => {
      onTaskUncompleted(updatedTask);
      notifications.show({
        title: 'Successfully uncompleted',
        message: `Task ${workCellTask.taskName} was set back to Not started.`,
        color: 'green',
      });
    }}
  />
);
